module.exports = __webpack_public_path__ + "img/img-2-4mobile.3233e3fc.webp";